// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be3eb4a1","453":"028f350d","455":"44916f7e","977":"f06afb3a"}[chunkId] + ".chunk.js";
};